<template>
  <el-main>
    <!-- 間隔 -->
    <br />
    <!-- data1 add btn -->
    <div class="formSubmitBtnBox">
      <el-button type="primary" @click="data1.addForm1.dialogVisible = true" align="right">新增場次</el-button>
    </div>
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table :data="data1.data.slice((currentPage - 1) * pagesize, currentPage * pagesize)" style="width: 100%" :default-sort="{ prop: 'session,status', order: 'descending' }">
      <el-table-column label="場次" prop="session" sortable>
        <template slot-scope="scope">
          {{ scope.row.session.substring(0, 10).replace(/-/g, '/') }}
        </template>
      </el-table-column>
      <el-table-column label="報名狀態" prop="status" sortable>
        <template slot-scope="scope">
          <div :style="scope.row.status ? 'color:#67C23A' : ''">
            {{ scope.row.status ? '開放中' : '已關閉' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="狀態管理">
        <template slot-scope="scope">
          <el-button @click="UpdateExamStatus(scope.row.id,scope.row.status)" style="margin:0 20px 0 0" :type="scope.row.status?'info':'success'"> {{ scope.row.status ? '關閉' : '開放' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="EditExamInfo(scope.row.id, scope.row.session)" style="margin:0 20px 0 0">編輯</el-button>
          <el-button @click="data1Delete(scope.$index)" type="danger">刪除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 40, 80]" :page-size="pagesize" layout="total, sizes,prev, pager, next" :total="data1.data.length" prev-text="上一頁" next-text="下一頁"> </el-pagination>
    </div>

    <!-- data1 add1 dialog -->
    <el-dialog title="新增" :visible.sync="data1.addForm1.dialogVisible" width="30%" @closed="data1AddForm1DialogClosed()" :close-on-click-modal="false">
      <el-form :model="data1.addForm1.data" status-icon :rules="data1.addForm1.rules" ref="data1AddForm1" label-width="100px" class="demo-ruleForm" v-loading.lock="data1.addForm1.loading">
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="data1.addForm1.data.session" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>

        <el-form-item label="" prop="">
          <el-alert v-show="data1.addForm1.errorMessage.length > 0" type="error" :closable="false">{{ data1.addForm1.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1AddForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  C_ExamSession_GetList, C_ExamInfo_GetList, C_ExamSession_Add, C_ExamSession_Delete, C_ExamSession_UpdateExamStatus,
} from '@/assets/js/api';

export default {
  data() {
    return {
      currentPage: 1, // 默認顯示第一頁
      pagesize: 10, //    每頁顯示筆數
      nowCategoryId: 1,
      sessionList: [],
      sessionTotalPeople: '',
      data1: {
        data: [],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: 'data1AddForm1',
          errorMessage: '',
          data: {
            session: '',
          },
          rules: {
            session: [{ required: true, message: '請輸入日期' }],
            content: [
              { required: true, message: '請輸入消息內容' },
              { min: 1, max: 100, message: '消息內容必須在100個字元內' },
            ],
          },
        },
      },
    };
  },
  mounted() {
    this.data1GetList();
  },
  watch: {
    $route() {},
    nowCategoryId() {
      this.data1GetList();
    },
  },
  methods: {
    handleSizeChange(size) {
      this.pagesize = size;
      /* console.log(this.pagesize) */
    },
    // 点击第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      /* console.log(this.currentPage) */
    },
    data1GetList() {
      C_ExamSession_GetList()
        .then((res) => {
          this.data1.data = res.data.data;
          console.log(this.data1.data);
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },
    getSessionTotalPeople(sessionId) {
      C_ExamInfo_GetList(sessionId)
        .then((res) => {
          this.sessionTotalPeople = res.data.data.length;
          console.log(res.data.data.length);
          return res.data.data.length;
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },

    // data1 add1
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = '';
    },
    data1AddForm1Submit() {
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.addForm1.loading = true;
          this.data1.addForm1.errorMessage = '';

          C_ExamSession_Add(this.data1.addForm1.data)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.errorMessage = err.response.data.message;
              this.data1.addForm1.loading = false;
            });
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm('確定刪除?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          C_ExamSession_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        })
        .catch(() => {});
    },

    UpdateExamStatus(id, status) {
      this.$confirm(`確定${status ? '關閉' : '開放'}?`, '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          C_ExamSession_UpdateExamStatus(id)
            .then((res) => {
              this.$notify({
                title: '成功',
                message: res.data.message,
                type: 'success',
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        })
        .catch();
    },
    goAlbum(newsId) {
      this.$router.push({ name: '/group/news/album', params: { id: newsId } });
    },
    EditExamInfo(sessionId, session) {
      this.$router.push({ path: 'register', query: { session: sessionId, date: session } });
    },
  },
};
</script>

<style scoped>
.top-div {
  align-items: center;
  padding: 5px 8px;
  width: 48px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  box-sizing: border-box;
  border-radius: 4px;

  color: #409eff;
}

.pagination {
  margin: 10px 0 0 0;
  text-align: center;
}
</style>
